import ImagesLoaded from "imagesloaded";
import Cart from "pages/cart";
import AddToWishlist from "components/wishlist";
import fitvids from "fitvids";

import { initializeSpoilers } from "pages/utils/spoilers";
import { initializeSideElements } from "pages/elements/side";
import { initializeMarkdownElements } from "pages/elements/markdown";
import { initializeButtonElements } from "pages/elements/button";
import { initializeCodeElements } from "pages/elements/code";

document.addEventListener("turbo:load", function () {
  fitvids(".build-video, .build-pxt", {
    players: ['iframe[src^="https://adafruit.pxt.io"'],
  });

  // initialize element handling

  // spoilers are used in multiple elements, anything using tinymce
  initializeSpoilers();
  initializeButtonElements(".button-element");
  initializeMarkdownElements(".markdown-element");
  initializeSideElements(".side-element");
  initializeCodeElements(".code-element");

  new AddToWishlist();
  new Cart();
});
